__webpack_require__.p = "/openapi/external-developer-shell/latest/";